/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SimpleDeviceStatusPercentageDto
 */
export interface SimpleDeviceStatusPercentageDto {
    /**
     *
     * @type {Date}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    date?: Date;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    unknownPercentage?: number;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    availablePercentage?: number;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    inUsePercentage?: number;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    faultedPercentage?: number;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    noCurtailmentPercentage?: number;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    lightCurtailmentPercentage?: number;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    heavyCurtailmentPercentage?: number;
    /**
     *
     * @type {number}
     * @memberof SimpleDeviceStatusPercentageDto
     */
    remainingPercentage?: number;
}

/**
 * Check if a given object implements the SimpleDeviceStatusPercentageDto interface.
 */
export function instanceOfSimpleDeviceStatusPercentageDto(
    value: object,
): value is SimpleDeviceStatusPercentageDto {
    return true;
}

export function SimpleDeviceStatusPercentageDtoFromJSON(
    json: any,
): SimpleDeviceStatusPercentageDto {
    return SimpleDeviceStatusPercentageDtoFromJSONTyped(json, false);
}

export function SimpleDeviceStatusPercentageDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SimpleDeviceStatusPercentageDto {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        unknownPercentage:
            json["unknownPercentage"] == null
                ? undefined
                : json["unknownPercentage"],
        availablePercentage:
            json["availablePercentage"] == null
                ? undefined
                : json["availablePercentage"],
        inUsePercentage:
            json["inUsePercentage"] == null
                ? undefined
                : json["inUsePercentage"],
        faultedPercentage:
            json["faultedPercentage"] == null
                ? undefined
                : json["faultedPercentage"],
        noCurtailmentPercentage:
            json["noCurtailmentPercentage"] == null
                ? undefined
                : json["noCurtailmentPercentage"],
        lightCurtailmentPercentage:
            json["lightCurtailmentPercentage"] == null
                ? undefined
                : json["lightCurtailmentPercentage"],
        heavyCurtailmentPercentage:
            json["heavyCurtailmentPercentage"] == null
                ? undefined
                : json["heavyCurtailmentPercentage"],
        remainingPercentage:
            json["remainingPercentage"] == null
                ? undefined
                : json["remainingPercentage"],
    };
}

export function SimpleDeviceStatusPercentageDtoToJSON(
    value?: SimpleDeviceStatusPercentageDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        unknownPercentage: value["unknownPercentage"],
        availablePercentage: value["availablePercentage"],
        inUsePercentage: value["inUsePercentage"],
        faultedPercentage: value["faultedPercentage"],
        noCurtailmentPercentage: value["noCurtailmentPercentage"],
        lightCurtailmentPercentage: value["lightCurtailmentPercentage"],
        heavyCurtailmentPercentage: value["heavyCurtailmentPercentage"],
        remainingPercentage: value["remainingPercentage"],
    };
}
